import React from 'react';
import I18n from 'i18n-js';
import { Modal, Button, Spin } from 'grab-ui';
import { ShopAddressSettingsModalContext } from './../shop-address-settings-modal-context';
import ShopAddressSettingsForm from './shop-address-settings-form';
import styles from './shop-address-settings-modal.less';

const ShopAddressSettingsModal = () => {
  const {
    formId,
    isFormLoading,
    cancelFormHandler,
    showModal,
  } = React.useContext(ShopAddressSettingsModalContext);

  return (
    <Modal
      centered
      className={styles.ShopAddressSettingsModal}
      visible={showModal}
      title={I18n.t('shopify.settings.addressSettingsSection.form.header')}
      onCancel={cancelFormHandler}
      footer={[
        <Button key="back" onClick={cancelFormHandler}>
          {I18n.t('v2.commonButton.cancel')}
        </Button>,
        <Button
          form={formId}
          key="submit"
          type="primary"
          htmlType="submit"
          loading={isFormLoading}
        >
          {I18n.t('v2.commonButton.submit')}
        </Button>,
      ]}
    >
      <Spin spinning={isFormLoading}>
        <ShopAddressSettingsForm />
      </Spin>
    </Modal>
  );
};

export default ShopAddressSettingsModal;
